/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect } from 'react';
import { SpacingCustom } from '../../../../../layout/Spacing/SpacingCustom';
import { GreySections } from '../../GreySections';
import { getListOfBlobsInContainer } from '../BlobStorage/utils/uploadFileToBlobStorage';
import useFileDialog from '../BlobStorage/hooks/useFileDialog';
import { useFileUpload } from '../BlobStorage/hooks/useFileUpload';
import { AiAnalyzerBottomButtons } from './AiAnalyzerBottomButtons';
import { AiAnalyzerDiffTableModal } from './AiAnalyzerDiffTableModal';
import { AiAnalyzerFileUploader } from './AiAnalyzerFileUploader';
import { AiAnalyzerShowFileList } from './AiAnalyzerShowFileList';
import { AiAnalyzerProcessing } from './AiAnalyzerProcessing';
import { LoaderBackground } from '../../../../../shared/LoaderBackground/LoaderBackground';
import { useAppSelector } from '../../../../../../redux/hooks';
import { rootState } from '../../../../../../redux/store';
import toast from 'react-hot-toast';

export const AIAnalyzer = () => {
    const { selectedFiles, openFileDialog } = useFileDialog();
    const { files, uploadFiles, lastUploadedFile } = useFileUpload();
    const { knowledgeGraphMergeData, knowledgeGraphMergeError, knowledgeGraphMergeLoading } = useAppSelector((state: rootState) => state.knowledgeGraphMerge);
    const {analyzerPassengerData, analyzerPassengerError, analyzerPassengerLoading} = useAppSelector((state:rootState) => state.createAndSendPassengers);
    

    // useEffect(() => {
    //     const getAllBlobs = async () => {
    //         try {
    //             console.log('All files in blob storage: ', await getListOfBlobsInContainer());
    //         } catch (error) {
    //             console.log(Error);
    //         }
    //     };
    //     getAllBlobs();
    // }, []);

    useEffect(() => {
        uploadFiles(selectedFiles);
    }, [selectedFiles]);

    // When button is changed fetch knowledge graph diff table
    // useEffect(()=>{
    //     console.log('Trigger')
    //     dispatch(fetchKnowladgeGraphDiffPending({
    //         url:`${process.env.REACT_APP_KNOWLEDGE_GRAPH_URL_ROOT}/knowledge_graph/differences/?file_url=${process.env.REACT_APP_BLOB_STORAGE_URL}/${process.env.REACT_APP_BLOB_STORAGE_CONTAINER}/${selectedKnowledgeFile}`,
    //         token: ''
    //     }))
    //     // if(selectedKnowledgeFile){
    //     // }
    // },[dispatch, selectedKnowledgeFile])
    

    // trigger and add knowledge graph to redux state before merging

    useEffect(() => {
        if (analyzerPassengerError) {
            toast.error(analyzerPassengerError);
        }
        if (analyzerPassengerData) {
            toast.success(analyzerPassengerData);
        }
    }, [analyzerPassengerData, analyzerPassengerError]);


    return (
        <>
            {/* <LoaderBackground label={'Jox'}/> */}
            <AiAnalyzerDiffTableModal/>
            

            <GreySections title={''} closeSection={false} hasArrow={false} showTitle={false}>
                <SpacingCustom paddingTop={1}>

                    <AiAnalyzerFileUploader func={(files: FileList) => uploadFiles(files)}/>
                    
                    <SpacingCustom paddingTop={2}></SpacingCustom>
                    <AiAnalyzerShowFileList files={files}/>
                    
                    <AiAnalyzerProcessing isLoading={analyzerPassengerLoading} message = {"...creating data sets"}/>
                    <AiAnalyzerProcessing isLoading={knowledgeGraphMergeLoading} message={'...merging'}/>
                    <AiAnalyzerBottomButtons/>

                </SpacingCustom>
            </GreySections>
        </>
    );
};
